import request from 'superagent'

import endpoints from '../config/endpoints'

export default () => {
  return new Promise((resolve, reject) =>
    request
      .get(`${endpoints.megaButtons}`)
      .then((result) => {
        if (!result.body) return reject(new Error(`Invalid response: ${result.body}`))
        return resolve(result.body)
      })
      .catch((error) => reject(new Error(error))),
  )
}
